/*
 * Lumos cart add-ons ("Complete your setup" in the cart drawer).
 *
 * Markup is rendered by snippets/lumos-cart-addons.liquid and replaced by the
 * host CartSection on every cart refresh, so this file only delegates clicks
 * from the document and never keeps references to rendered nodes. Each change
 * holds a LumosCartOperations mutation lock, posts to the locale-aware Shopify
 * cart route, then asks the host to re-render with the usual cart:refresh.
 */
(function (global) {
  'use strict';

  if (global.LumosCartAddons) return;

  var doc = global.document;
  var ROOT = '[data-lumos-cart-addons]';
  var MESSAGES = {
    size: 'Choose a size to add',
    busy: 'Please wait a moment and try again.',
    failed: 'Unable to update cart.'
  };

  function route(name, fallback) {
    var routes = global.routes || {};
    var base = typeof routes[name] === 'string' && routes[name] ? routes[name] : fallback;
    return base.replace(/\.js$/, '') + '.js';
  }

  function itemFor(element) {
    return element && element.closest ? element.closest('[data-lumos-addon]') : null;
  }

  // The section carries the store's translated messages (data-msg-*); English
  // stays as the fallback for markup rendered before translations existed.
  function text(item, key) {
    var root = item && item.closest ? item.closest(ROOT) : null;
    var value = root && root.getAttribute('data-msg-' + key);
    return value || MESSAGES[key];
  }

  function message(item, text) {
    var node = item && item.querySelector('[data-lumos-addon-message]');
    if (!node) return;
    if (text) {
      node.textContent = text;
      node.hidden = false;
    } else {
      node.textContent = '';
      node.hidden = true;
    }
  }

  function setBusy(button, busy) {
    if (!button) return;
    if (busy) {
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('disabled', 'disabled');
    } else {
      button.removeAttribute('aria-busy');
      button.removeAttribute('disabled');
    }
  }

  function loading(name) {
    doc.dispatchEvent(new global.CustomEvent('theme:loading:' + name));
  }

  function post(url, body) {
    return global.fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (content) {
        if (!response.ok) {
          var error = new Error((content && (content.description || content.message)) || '');
          error.status = response.status;
          throw error;
        }
        return content;
      });
    });
  }

  function mutate(item, button, url, body) {
    var operations = global.LumosCartOperations;
    var drawer = item.closest('#sidebar-cart') || doc.documentElement;
    var operation = null;

    if (operations && typeof operations.beginCartMutation === 'function') {
      operation = operations.beginCartMutation({ element: drawer }, { kind: 'addon', item: item.getAttribute('data-lumos-addon') });
      if (!operation) {
        message(item, text(item, 'busy'));
        return Promise.resolve(false);
      }
    }

    message(item, '');
    setBusy(button, true);
    loading('start');

    return post(url, body).then(function () {
      if (operation) operations.finishCartOperation(operation);
      doc.documentElement.dispatchEvent(new global.CustomEvent('cart:refresh', { bubbles: true }));
      return true;
    }).catch(function (error) {
      if (operation) operations.failCartOperation(operation);
      if (item.isConnected !== false) {
        setBusy(button, false);
        message(item, error && error.message ? error.message : text(item, 'failed'));
      }
      return false;
    }).then(function (result) {
      loading('end');
      return result;
    });
  }

  function selectSize(item, chip) {
    if (chip.disabled) return;
    var chips = item.querySelectorAll('[data-lumos-addon-size]');
    for (var index = 0; index < chips.length; index += 1) {
      var selected = chips[index] === chip;
      chips[index].classList.toggle('is-selected', selected);
      chips[index].setAttribute('aria-checked', selected ? 'true' : 'false');
    }
    var add = item.querySelector('[data-lumos-addon-add]');
    if (add) add.setAttribute('data-variant-id', chip.getAttribute('data-variant-id') || '');
    message(item, '');
  }

  function onClick(event) {
    var target = event.target && event.target.closest
      ? event.target.closest(ROOT + ' [data-lumos-addon-size], ' + ROOT + ' [data-lumos-addon-add], ' + ROOT + ' [data-lumos-addon-remove]')
      : null;
    if (!target) return;
    var item = itemFor(target);
    if (!item) return;
    event.preventDefault();

    if (target.hasAttribute('data-lumos-addon-size')) {
      selectSize(item, target);
      return;
    }

    if (target.getAttribute('aria-busy') === 'true') return;

    if (target.hasAttribute('data-lumos-addon-add')) {
      var variantId = Number(target.getAttribute('data-variant-id'));
      if (!variantId) {
        message(item, text(item, 'size'));
        return;
      }
      mutate(item, target, route('cartAddUrl', '/cart/add'), { items: [{ id: variantId, quantity: 1 }] });
      return;
    }

    var lineKey = target.getAttribute('data-line-key');
    if (lineKey) mutate(item, target, route('cartChangeUrl', '/cart/change'), { id: lineKey, quantity: 0 });
  }

  doc.addEventListener('click', onClick);
  global.LumosCartAddons = { version: 1, messages: MESSAGES };
}(window));
